module.exports = __webpack_public_path__ + "img/node-charging-transparent.e8cb9e36.webp";